export default function isAlliancePolicy(provider) {
  return (
    typeof provider === "string" && provider?.split(":")?.[0] === "alliance"
  );
}
